<template>
  <div class="zj-layout-header">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ZjLayoutHeader'
}
</script>
